// extracted by mini-css-extract-plugin
module.exports = {"membershipReportContainer":"SalesInsightsReport_membershipReportContainer__1sIZz"};